export default __webpack_public_path__ + "static/dog-snow-a077e42a23c0bede0dbcf87b59546bde.svg";